import es from 'date-fns/locale/es';
import PropTypes from 'prop-types';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { registerLocale } from 'react-datepicker';
import { useSelector } from 'react-redux';
import { BranchOfficeFilter } from './filters/BranchOfficeFilter';
import { CharacteristicsFilter } from './filters/CharacteristicsFilter';
import { NeighborhoodsFilter } from './filters/NeighborhoodsFilter';
import { OperationTypeFilter } from './filters/OperationTypeFilter';
import { PriceFilter } from './filters/PriceFilter';
import { PropertyTypeFilter } from './filters/PropertyTypeFilter';
import { RealEstatesFilter } from './filters/RealEstatesFilter';
import { SearchBoxFilter } from './filters/SearchBoxFilter';
import { SharedFilter } from './filters/SharedFilter';
import { StatusFilter } from './filters/StatusFilter';
import { SurfaceFilter } from './filters/SurfaceFilter';
import { ExtrasFilter } from './filters/ExtrasFilter';
import { AddressBoxFilter } from './filters/AddressBoxFilter';
registerLocale('es', es);

const ListFilterComponent = ({
  setFiltersAndSort,
  filtersAndSort,
  branchOffices,
  submitSearch,
  searching,
  searchAddress,
  searchingAddress,
  noBranchOffice,
  noStatus,
  noShared,
  neighborhoods,
  realEstates
}) => {
  const types = useSelector(state => state.props.types);

  return (
    <Card className="bg-white">
      <Card.Body>
        <Card.Title className="border-bottom pb-2">Filtrar Por:</Card.Title>

        <Row className="g-3">
          <Col xs={12}>
            <SearchBoxFilter
              searching={searching}
              submitSearch={submitSearch}
            />
          </Col>
          <Col xs={12}>
            <AddressBoxFilter
              searching={searchingAddress}
              submitSearch={searchAddress}
            />
          </Col>

          {!noBranchOffice && (
            <Col xs={12} sm={6} lg={12}>
              <BranchOfficeFilter
                branchOffices={branchOffices}
                setFiltersAndSort={setFiltersAndSort}
                filtersAndSort={filtersAndSort}
              />
            </Col>
          )}

          <Col xs={12} sm={6} lg={12}>
            <OperationTypeFilter
              setFiltersAndSort={setFiltersAndSort}
              filtersAndSort={filtersAndSort}
            />
          </Col>

          <Col xs={12} sm={6} lg={12}>
            <PropertyTypeFilter
              types={types}
              setFiltersAndSort={setFiltersAndSort}
              filtersAndSort={filtersAndSort}
            />
          </Col>

          {!noStatus && (
            <Col xs={12} sm={6} md={3} lg={12}>
              <StatusFilter
                setFiltersAndSort={setFiltersAndSort}
                filtersAndSort={filtersAndSort}
              />
            </Col>
          )}

          {!noShared && (
            <Col xs={12} sm={6} md={3} lg={12}>
              <SharedFilter
                setFiltersAndSort={setFiltersAndSort}
                filtersAndSort={filtersAndSort}
              />
            </Col>
          )}

          {!!realEstates?.length && (
            <RealEstatesFilter
              realEstates={realEstates}
              setFiltersAndSort={setFiltersAndSort}
              filtersAndSort={filtersAndSort}
            />
          )}

          {!!neighborhoods?.length && (
            <Col xs={12}>
              <NeighborhoodsFilter
                neighborhoods={neighborhoods}
                setFiltersAndSort={setFiltersAndSort}
                filtersAndSort={filtersAndSort}
              />
            </Col>
          )}

          <hr className="mb-0" />

          <Col xs={12} className="mt-2">
            <PriceFilter
              filtersAndSort={filtersAndSort}
              setFiltersAndSort={setFiltersAndSort}
            />
          </Col>

          <hr className="mb-0" />

          <Col xs={12} className="mt-2">
            <SurfaceFilter
              filtersAndSort={filtersAndSort}
              setFiltersAndSort={setFiltersAndSort}
            />
          </Col>

          <hr className="mb-0" />

          <Col xs={12} md={6} lg={12} className="mt-2">
            <CharacteristicsFilter
              filtersAndSort={filtersAndSort}
              setFiltersAndSort={setFiltersAndSort}
              name="ambiences"
              label="Ambientes"
              singular="ambiente"
              plural="ambientes"
            />
          </Col>

          <Col xs={12} md={6} lg={12}>
            <CharacteristicsFilter
              filtersAndSort={filtersAndSort}
              setFiltersAndSort={setFiltersAndSort}
              name="bedrooms"
              label="Habitaciones"
              singular="habitacion"
              plural="habitaciones"
            />
          </Col>

          <Col xs={12} md={6} lg={12}>
            <CharacteristicsFilter
              filtersAndSort={filtersAndSort}
              setFiltersAndSort={setFiltersAndSort}
              name="bathrooms"
              label="Baños"
              singular="baño"
              plural="baños"
            />
          </Col>

          <Col xs={12} md={6} lg={12}>
            <CharacteristicsFilter
              filtersAndSort={filtersAndSort}
              setFiltersAndSort={setFiltersAndSort}
              name="garages"
              label="Cocheras"
              singular="cochera"
              plural="cocheras"
            />
          </Col>
          <hr className="mb-0" />

          <Col xs={12} md={6} lg={12}>
            <ExtrasFilter
              filtersAndSort={filtersAndSort}
              setFiltersAndSort={setFiltersAndSort}
              label="Extras"
            />
          </Col>

          <Col xs={12}>
            <hr className="mt-0" />

            <Button
              variant="secondary"
              className="w-100"
              onClick={() => {
                setFiltersAndSort(prev => ({
                  ...prev,
                  status: [],
                  property: 0,
                  propertyTypes: [],
                  realEstates: [],
                  operation: 0,
                  shared: 'all',
                  price: {
                    min: '',
                    max: '',
                    currency: 'ARS'
                  },
                  surface: {
                    min: '',
                    max: '',
                    type: 'totalSurface'
                  },
                  ambiences: [],
                  bedrooms: [],
                  bathrooms: [],
                  garages: [],
                  neighborhoods: [],
                  extras: []
                }));
              }}
            >
              Limpiar filtros
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

ListFilterComponent.propTypes = {
  setFiltersAndSort: PropTypes.func.isRequired,
  filtersAndSort: PropTypes.object.isRequired,
  branchOffices: PropTypes.array,
  branchOffice: PropTypes.number,
  setBranchOffice: PropTypes.func,
  submitSearch: PropTypes.func.isRequired,
  searching: PropTypes.bool.isRequired,
  searchAddress: PropTypes.func.isRequired,
  searchingAddress: PropTypes.bool.isRequired,
  noBranchOffice: PropTypes.bool,
  noStatus: PropTypes.bool,
  noShared: PropTypes.bool,
  neighborhoods: PropTypes.array,
  realEstates: PropTypes.array
};

export default ListFilterComponent;
